/* tslint:disable */
/* eslint-disable */
/**
 * Trendtours CMS API
 * ISO API for the IBE. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiPromotionDataRequest
 */
export interface ApiPromotionDataRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiPromotionDataRequest
     */
    packageCodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ApiPromotionDataRequest
     */
    promotionCandidate?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiPromotionDataRequest
     */
    basePrice?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiPromotionDataRequest
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiPromotionDataRequest
     */
    endDate?: string;
}

export function ApiPromotionDataRequestFromJSON(json: any): ApiPromotionDataRequest {
    return ApiPromotionDataRequestFromJSONTyped(json, false);
}

export function ApiPromotionDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPromotionDataRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'packageCodes': !exists(json, 'packageCodes') ? undefined : json['packageCodes'],
        'promotionCandidate': !exists(json, 'promotionCandidate') ? undefined : json['promotionCandidate'],
        'basePrice': !exists(json, 'basePrice') ? undefined : json['basePrice'],
        'startDate': !exists(json, 'startDate') ? undefined : (json['startDate']),
        'endDate': !exists(json, 'endDate') ? undefined : (json['endDate']),
    };
}

export function ApiPromotionDataRequestToJSON(value?: ApiPromotionDataRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'packageCodes': value.packageCodes,
        'promotionCandidate': value.promotionCandidate,
        'basePrice': value.basePrice,
        'startDate': value.startDate === undefined ? undefined : (value.startDate),
        'endDate': value.endDate === undefined ? undefined : (value.endDate),
    };
}


// custom code here ##################################################################################################################
function toUTC(date) {
  var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
  return new Date(date_utc);
}
